import { Spin } from "antd";
import type { WorkerLogtimeMonthlyV2Response } from "@lhd/hooks";
import SummaryItem from "../../components/SummaryItem";
import { SummaryContainer, SummaryItems } from "./styled";

type Props = {
  fontSize: number;
  loading: boolean;
  summary?: WorkerLogtimeMonthlyV2Response["summary"];
};

export const formatTimeWithDecimal = (
  time: string | null | undefined,
): string => {
  if (!time) return "";

  const [hours, minutes] = time.split(":").map(Number);
  return `${time} （${(hours + minutes / 60).toFixed(2)}H）`;
};

const MonthlySummary = ({ fontSize, loading, summary }: Props) => (
  <SummaryContainer $fontSize={fontSize}>
    <Spin spinning={loading}>
      <SummaryItems>
        <SummaryItem label="出勤日数:" value={summary?.work_days || "0"} />
        <SummaryItem
          label="労働時間合計:"
          value={
            summary?.working_hours
              ? formatTimeWithDecimal(summary.working_hours)
              : "00:00"
          }
        />
        <SummaryItem
          label="休憩時間合計:"
          value={
            summary?.break_hours
              ? formatTimeWithDecimal(summary.break_hours)
              : "00:00"
          }
        />
      </SummaryItems>
    </Spin>
  </SummaryContainer>
);

export default MonthlySummary;
